// extracted by mini-css-extract-plugin
module.exports = {"curveContainer":"CurvedBox_curveContainer__BexAd","b":"CurvedBox_b__1tLOx","ba":"CurvedBox_ba__3TZgf","a":"CurvedBox_a__3VFpZ"};